/* eslint-disable @typescript-eslint/no-unused-vars */
import { availableShippingCountryOptions } from '@/components/ShippingInfo/LiveShippingInfo/components/ShippingPickupOptions/components/LiveShipping/components/CustomShippingRateModal/components/LocationForm/ShippingRateModalLocationForm.constants';
import { getDefaultAddressCountryCode } from '@/redux/modules/account/user/user.selectors';
import { LIVE_SHIPPING_METHOD_TRANSLATION_KEY } from '@/components/ShippingInfo/LiveShippingInfo/components/ShippingPickupOptions/components/LiveShipping/LiveShippingMethodRow.constants';
import { OptionType, Select } from '@liveauctioneers/hammer-ui-core/select';
import { useAppSelector } from '@/redux/hooks';
import { useIntl } from '@liveauctioneers/hammer-ui-core/intl';
import EnterPostalCode from '@/components/ShippingInfo/LiveShippingInfo/components/ShippingPickupOptions/components/LiveShipping/components/CustomShippingRateModal/components/LocationForm/components/PostalCode/EnterPostalCode';
import RateUnavailable from '@/components/ShippingInfo/LiveShippingInfo/components/ShippingPickupOptions/components/LiveShipping/components/CustomShippingRateModal/components/LocationForm/components/RateUnavailable/RateUnavailable';
import React, { useCallback, useEffect, useState } from 'react';
import styled, { css } from 'styled-components';

export type ShippingRateModalLocationFormProps = {
    onClose: () => void;
    onSubmit: (country: string, postalCode: string) => Promise<void>;
};

const ShippingRateModalLocationForm = ({ onClose, onSubmit }: ShippingRateModalLocationFormProps) => {
    const { formatMessage } = useIntl();

    const [isLoading, setIsLoading] = useState(false);

    const defaultAddressCountryCode = useAppSelector(getDefaultAddressCountryCode);
    const [selectedCountry, setSelectedCountry] = useState(
        availableShippingCountryOptions.find(({ value }) => value === defaultAddressCountryCode) ??
            availableShippingCountryOptions.find(({ value }) => value === 'US')
    );
    const [postalCode, setPostalCode] = useState('');

    const [isUnitedStates, setIsUnitedStates] = useState(selectedCountry.value === 'US');

    const onChangeCountry = useCallback((newValue: OptionType) => {
        setSelectedCountry(newValue.value);
    }, []);

    const onChangePostalCode = useCallback((newPostalCode: string) => {
        setPostalCode(newPostalCode);
    }, []);

    useEffect(() => {
        if (isLoading) {
            let country = selectedCountry?.value ?? selectedCountry;
            onSubmit(country, postalCode).then(() => {
                setIsLoading(false);
            });
        }
    }, [isLoading, onSubmit, postalCode, selectedCountry]);

    return (
        <StyledRateForm>
            <Select
                data-testid="shipping-rate-modal.country-select"
                defaultValue={selectedCountry}
                labelText={formatMessage({
                    id: `${LIVE_SHIPPING_METHOD_TRANSLATION_KEY}.rateModal.countrySelectLabel`,
                })}
                onChange={onChangeCountry}
                options={availableShippingCountryOptions}
                usePortalMenu
            />

            <EnterPostalCode
                countryCode={selectedCountry.value}
                isLoading={isLoading}
                onChangePostalCode={onChangePostalCode}
                onSubmit={() => {
                    setIsLoading(true);
                }}
            />
        </StyledRateForm>
    );
};

export default ShippingRateModalLocationForm;

const StyledRateForm = styled.section`
    & > :not(:last-child) {
        margin-bottom: 24px;
    }

    & > :last-child {
        margin-top: 32px;
        ${({ theme }) => css`
            @media (max-width: ${theme.breakpoints.tabletNarrowWidth}) {
                width: 100%;
            }
        `}
    }
`;
